import { render, staticRenderFns } from "./RolesProfiles.vue?vue&type=template&id=30dd8b8c"
import script from "./RolesProfiles.vue?vue&type=script&lang=js"
export * from "./RolesProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports